/**
 * @file index.tsx
 * @description Public entry point for the ContractDrawerStatusStrip.
 *   The default export is now the Container — which owns visibility
 *   gating, date formatting, and Edit-button gating — so the View
 *   stays strictly presentational per the project Container/View rule.
 * @module features/contracts/components/ContractDrawerStatusStrip
 */

export { default } from "./ContractDrawerStatusStripContainer";
export type { ContractDrawerStatusStripContainerProps } from "./ContractDrawerStatusStripContainer";
export type { ContractDrawerStatusStripViewProps } from "./ContractDrawerStatusStripView";
